import type { UsersStore } from './interfaces'

export const actions = {
  setLoading (this: UsersStore, payload: UsersStore['loading']): void {
    this.loading = payload
  },
  setSaving (this: UsersStore, payload: UsersStore['saving']): void {
    this.saving = payload
  },
  setUsers (this: UsersStore, payload: UsersStore['users']): void {
    this.users = payload
  },
  setMeta (this: UsersStore, payload: UsersStore['meta']): void {
    this.meta = payload
  },
  setTeams (this: UsersStore, payload: UsersStore['teams']): void {
    this.teams = payload
  },
  setFilterSearch (this: UsersStore, payload: UsersStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setFilterRoles (this: UsersStore, payload: UsersStore['filterRoles']): void {
    this.filterRoles = payload
  },
  setFilterTeams (this: UsersStore, payload: UsersStore['filterTeams']): void {
    this.filterTeams = payload
  },
  setFilterStatus (this: UsersStore, payload: UsersStore['filterStatus']): void {
    this.filterStatus = payload
  },
  setCurrentPage (this: UsersStore, payload: UsersStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: UsersStore, payload: UsersStore['perPage']): void {
    this.perPage = payload
  },
  setUserToDelete (this: UsersStore, payload: UsersStore['userToDelete']): void {
    this.userToDelete = payload
  },
  setCurrentUser (this: UsersStore, payload: UsersStore['currentUser']): void {
    this.currentUser = payload
  },
  resetFilters (this: UsersStore): void {
    this.filterSearch = null
    this.filterRoles = []
    this.filterTeams = []
    this.filterStatus = null
    this.currentPage = 1
  },
}
